import React, { useEffect } from "react";

// import "../../assets/vendor/css/bootstrap.css";
import { useLocation, useNavigate } from "react-router-dom";
import Master from "../components/layout/master";
import { checkLogin } from "../utils/customFn";
import useApiRequest from "../hook/useApiRequest";
import { useDispatch } from "react-redux";
import { API_ENDPOINTS } from "../constants/endPoints";
import {
  setlangauges,
  setProfileData,
  setCities,
} from "../redux/user/slice/userAuthSlice";

function Main() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, fetchData } = useApiRequest();

  const fetchLangaugeData = async () => {
    try {
      const url = `${API_ENDPOINTS?.get_langauges}`;
      const response = await fetchData(`${url}`, navigate);
      if (response) {
        dispatch(setlangauges(response?.docs));
      }
    } finally {
    }
  };

  const fetchCitiesData = async () => {
    try {
      const url = `${API_ENDPOINTS?.get_cities}`;
      const response = await fetchData(`${url}`, navigate);
      if (response) {
        dispatch(setCities(response));
      }
    } finally {
    }
  };

  const fetchProfileData = async () => {
    const response = await fetchData(`${API_ENDPOINTS?.get_profile}`, navigate);
    if (response) {
      dispatch(setProfileData(response));
    }
  };

  useEffect(() => {
    fetchLangaugeData();
    fetchCitiesData();
    fetchProfileData();
  }, []);

  useEffect(() => {
    // Check login status on mount
    if (!checkLogin()) {
      navigate("/");
    }
  }, []);

  // Top To Scroll
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);

  return <Master />;
}

export default Main;
